import { render, staticRenderFns } from "./simulador-analise.vue?vue&type=template&id=1727aca5&"
import script from "./simulador-analise.vue?vue&type=script&lang=js&"
export * from "./simulador-analise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1727aca5')) {
      api.createRecord('1727aca5', component.options)
    } else {
      api.reload('1727aca5', component.options)
    }
    module.hot.accept("./simulador-analise.vue?vue&type=template&id=1727aca5&", function () {
      api.rerender('1727aca5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modal/workspace/simulador-analise.vue"
export default component.exports